import { css } from 'styled-components/macro'

/**
 * Visible gap between the clear button and the search capsule border.
 * Pair with `ClearButton { right: 0 }` — the capsule supplies this padding,
 * not the button offset.
 */
export const SEARCH_BAR_CLEAR_EDGE_INSET = '8px'

/** Shared list/cashier search ink. Lives on SearchBar/Styles.ts Input —
 *  list scopes must not re-declare font-size or they fork the type again.
 *  14px read small after the rebrand; 15px matches Sales + cashier. */
export const SEARCH_BAR_FONT_SIZE = '15px'

/** Width of the leading magnifier well; the input's own padding-left. */
export const SEARCH_BAR_ICON_WIDTH = '3rem'

/** List-header search capsules (Manage catalog, Sales, etc.). */
export const listHeaderSearchClearChrome = css`
  [data-testid='list-header']
    #search-and-filter
    [data-testid='search-clear-button'] {
    right: 0;
  }
`

/** Cashier toolbar / checkout search (no list-header wrapper). */
export const searchClearChrome = css`
  #search-and-filter [data-testid='search-clear-button'] {
    right: 0;
  }
`

/**
 * When SearchBar is styled as the capsule root (e.g. Order ahead board)
 * instead of going through SearchAndFilter.
 *
 * Outer padding does not inset absolute children — set `right` on the button.
 */
export const searchWrapClearChrome = css`
  box-sizing: border-box;

  & > div:first-child {
    height: 100%;
    position: relative;
  }

  [data-testid='search-clear-button'] {
    right: ${SEARCH_BAR_CLEAR_EDGE_INSET};
    top: 0;
    bottom: 0;
    transform: none;
    margin-top: auto;
    margin-bottom: auto;
  }
`

/**
 * SearchBar inside a `#scrollArea` form scope (catalogFormScopeStyles). The
 * blanket input rule there re-pads every input and takes the magnifier
 * clearance the capsule relies on — give it back.
 */
export const formScopeSearchChrome = css`
  #scrollArea #search-and-filter input {
    height: 100%;
    border: none;
    border-radius: 0;
    padding: 0 calc(32px + 6px) 0 ${SEARCH_BAR_ICON_WIDTH};
    background: transparent;
  }
`
